export default function Toggle({on, setOn, height = '1em'}) {

  const toggle = () => { setOn(!on); }

  return (
    <div
        onClick={toggle}
        style={{
          height,
          aspectRatio: 1.8,
          background: on ? '#22c55e' : '#ef4444',
          borderRadius: '55% / 100%',
          display: 'flex',
          alignItems: 'center',
          cursor: 'pointer',
          boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
          transition: 'background 0.2s',
          filter: 'saturate(0.85)',
          fontSize: height
        }}
        aria-label="Toggle theme"
      >
        <div
          style={{
            height: '85%',
            aspectRatio: 1,
            borderRadius: '50%',
            background: '#fff',
            boxShadow: '0 1px 4px rgba(0,0,0,0.10)',
            transform: on ? 'translateX(100%)' : 'translateX(10%)',
            transition: 'transform 0.2s',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: '0.8em',
            color: on ? '#22c55e' : '#ef4444',
            userSelect: 'none',
          }}
        >
          {on ? '✔' : '✖'}
        </div>
      </div>
    )
}